import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalPush() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-t border-white/5 relative overflow-hidden" data-id="element-104">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-[0.03]" data-id="element-105" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-107">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-108">
            En 30 días podés estar vendiendo… <br data-id="element-109" />
            <span className="text-gold italic font-normal" data-id="element-110">
              o seguir pensando.
            </span>
          </h2>

          <p className="text-xl sm:text-2xl text-cream-muted font-light max-w-2xl mx-auto mb-12" data-id="element-111">
            Sin experiencia. Sin inversión grande.{' '}
            <br className="hidden sm:block" data-id="element-112" />
            <span className="font-medium text-cream" data-id="element-113">
              Solo necesitás empezar.
            </span>
          </p>

          <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative inline-flex items-center justify-center gap-3 px-10 py-5 text-xl font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_40px_rgba(212,168,83,0.3)] hover:shadow-[0_0_60px_rgba(212,168,83,0.5)]" data-id="element-114">
            <span className="relative z-10 flex items-center gap-2" data-id="element-115">
              EMPEZAR AHORA
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-116" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-117" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}